import { QueryClient } from '@tanstack/react-query';
import { showError } from '../utils/notification.utils';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      onError: (error: unknown) => {
        const message = error instanceof Error ? error.message : 'Something went wrong';
        showError({ title: 'Request Failed', message });
      },
    },
  },
});
